import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import LifeAtProgressBar from "@common/LifeAtProgressBar/LifeAtProgressBar";
import { Signal } from "@preact/signals-react";
import ConfettiAnimation from "@resources/animations/62717-confetti.json";
import { ClientTaskListType } from "../TaskManagementTypes";

const TaskListProgressBarWrapper = styled.div<{ isVisible: boolean }>`
    display: flex;
    width: 100%;
    position: relative;
    opacity: ${({ isVisible }) => (isVisible ? "100%" : "0%")};
`;

const ConfettiAnimationOptions = {
    loop: false,
    autoplay: true,
    animationData: ConfettiAnimation,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
    },
};

interface TaskListProgressBarProps {
    readonly taskList$: Signal<ClientTaskListType>;
    readonly isVisible: boolean;
}
export default function TaskListProgressBar(props: TaskListProgressBarProps) {
    const totalTaskCount = Object.values(props.taskList$.value).length;
    const completedTaskCount =
        Object.values(props.taskList$.value).filter((task) => task.status === "COMPLETE").length ?? 0;

    const [playTasksCompletedAnimation, setPlayTasksCompletedAnimation] = useState(false);

    // Determines the fill of the progress bar
    const [completionPercentage, setCompletionPercentage] = useState(0);

    useEffect(() => {
        const percentage = (completedTaskCount / totalTaskCount) * 100 || 0;
        setCompletionPercentage(percentage);

        if (percentage >= 100 && totalTaskCount > 0) {
            setPlayTasksCompletedAnimation(true);

            // After 3.5 seconds, stop the animation.
            setTimeout(() => setPlayTasksCompletedAnimation(false), 3500);
        } else {
            setPlayTasksCompletedAnimation(false);
        }
    }, [totalTaskCount, completedTaskCount]);

    return (
        <TaskListProgressBarWrapper isVisible={props.isVisible}>
            {playTasksCompletedAnimation && (
                <Lottie
                    {...ConfettiAnimationOptions}
                    height={"fit-content"} // these height/width values make the confetti
                    width={"100%"} // display correctly when the widget is resized.
                    style={{ position: "absolute", pointerEvents: "none", bottom: 0 }}
                    loop={!playTasksCompletedAnimation}
                />
            )}

            <LifeAtProgressBar
                progressPercentage={completionPercentage}
                progressNum={completedTaskCount}
                progressTotal={totalTaskCount}
            />
        </TaskListProgressBarWrapper>
    );
}
